import React from 'react'
import { useTranslation } from 'react-i18next';
import Table from '../Table';
import chromeIcon from '../../assets/images/chrome.svg';
import firefoxIcon from '../../assets/images/firefox.svg';
import safariIcon from '../../assets/images/safari.svg';
import edgeIcon from '../../assets/images/edge.svg';
import explorerIcon from '../../assets/images/explorer.svg';
import BraveIcon from '../../assets/images/brave.svg';
import operaIcon from '../../assets/images/opera.svg';
import './compability-content.scss';
import tickIcon from '../../assets/images/tick.svg';

const CompatibilityContent = () => {
	const { t } = useTranslation();

	const columns = [
		{
			heading: `${t('browser')}`,
			accessor: 'browser',
			Cell: ({ row }) => <div className='compat-browser-cell'>
				<div className="compat-browser-cell__icon-wrap">
					<img src={row.icon} alt="" className="compat-browser-cell__icon" />
				</div>
				<span className="compat-browser-cell__name">{row.browser}</span>
			</div>
		},
		{
			heading: `${t('min_version')}`,
			accessor: 'version'
		},
		{
			heading: `${t('status')}`,
			accessor: 'status',
			Cell: ({ }) => <div className="compat-status">
				<img src={tickIcon} alt='status' className="compat-status__icon" />
			</div>
		}
	]

	const data = [
		{
			browser: 'Chrome',
			icon: chromeIcon,
			version: '90.0.4430.93',
			status: 'active'
		},
		{
			browser: 'Firefox',
			icon: firefoxIcon,
			version: '100.0.1',
			status: 'active'
		},
		{
			browser: 'Microsoft Edge',
			icon: edgeIcon,
			version: '90.0.881.51',
			status: 'active'
		},
		{
			browser: 'Safari',
			icon: safariIcon,
			version: '17.0.0',
			status: 'active'
		},
		{
			browser: 'Opera',
			icon: operaIcon,
			version: '100.0.4815.47',
			status: 'active'
		},
		{
			browser: 'Internet Explorer',
			icon: explorerIcon,
			version: '8.0.6001.18',
			status: 'active'
		},
		{
			browser: 'Brave',
			icon: BraveIcon,
			version: '1.41.100',
			status: 'active'
		},
	]

	return (
		<div className='compatibility-page'>
			<div className="library-page__container">
				<div className="library-page__header">
					<h1 className="library-page__title">{t('page_compability')}</h1>
					<p className="library-page__description">
						{t('compatibilit_desc')}
					</p>
				</div>
				<div className="content-panel">
					<Table
						column={columns}
						data={data}
						showPagination={false}
						onSortedList={() => null}
						variant="modern"
					/>
				</div>
			</div>
		</div>
	)
}

export default CompatibilityContent